<template>
	<div class="insideBody">
		<div class="rankList">
			<ul>
				<li class="li1">
					<div class="top clr">
						<div class="fl">全国排行榜</div>
						<div class="fr">top 10</div>
					</div>
					<div class="list_con">
						
						<div class="list clr" v-for="(item,index) in quanguoData" :key="index" :class="item.paiming ? 'on':''" >
							<template v-if="item.paiming">
								<div class="listcon">
									<div class="titmy">我的排名</div>
									<div class="end clr">
										<div class="num fl"></div>
										<div class="namecon fl clr">
											<img class="fl img" :src="$url+item.avatar" />
											<div class="tit">{{item.username}}</div>
										</div>
										<div class="number fr">{{item.jifen}}</div>
									</div>
								</div>
							</template>
							<template v-else>
								<div class="num fl">{{index+1}}</div>
								<div class="namecon fl clr">
									<img class="fl img" :src="$url+item.avatar" />
									<div class="tit">{{item.username}}</div>
								</div>
								<div class="number fr">{{item.jifen}}</div>
							</template>
						</div>
						
						<div class="list on clr" v-if="Object.keys(quanguoMyself).length > 0">
							<div class="listcon">
								<div class="titmy">我的排名</div>
								<div class="end clr">
									<div class="num fl">{{quanguoMyself.paiming}}</div>
									<div class="namecon fl clr">
										<img class="fl img" :src="$url+quanguoMyself.avatar" />
										<div class="tit">{{quanguoMyself.username}}</div>
									</div>
									<div class="number fr">{{quanguoMyself.jifen}}</div>
								</div>
							</div>
						</div>
						
					</div>					
				</li>
				<li class="li2">
					<div class="top clr">
						<div class="fl">全省排行榜</div>
						<div class="fr">top 10</div>
					</div>
					<div class="list_con">
						
						<div class="list clr" v-for="(item,index) in quanshenData" :key="index" :class="item.paiming ? 'on':''" >
							<template v-if="item.paiming">
								<div class="listcon">
									<div class="titmy">我的排名</div>
									<div class="end clr">
										<div class="num fl"></div>
										<div class="namecon fl clr">
											<img class="fl img" :src="$url+item.avatar" />
											<div class="tit">{{item.username}}</div>
										</div>
										<div class="number fr">{{item.jifen}}</div>
									</div>
								</div>
							</template>
							<template v-else>
								<div class="num fl">{{index+1}}</div>
								<div class="namecon fl clr">
									<img class="fl img" :src="$url+item.avatar" />
									<div class="tit">{{item.username}}</div>
								</div>
								<div class="number fr">{{item.jifen}}</div>
							</template>
						</div>
						
						<div class="list on clr" v-if="Object.keys(quanshenMyself).length > 0">
							<div class="listcon">
								<div class="titmy">我的排名</div>
								<div class="end clr">
									<div class="num fl">{{quanshenMyself.paiming}}</div>
									<div class="namecon fl clr">
										<img class="fl img" :src="$url+quanshenMyself.avatar" />
										<div class="tit">{{quanshenMyself.username}}</div>
									</div>
									<div class="number fr">{{quanshenMyself.jifen}}</div>
								</div>
							</div>
						</div>
						
					</div>					
				</li>
				<li class="li3">
					<div class="top clr">
						<div class="fl">本校排行榜</div>
						<div class="fr">top 10</div>
					</div>
					<div class="list_con">
						
						<div class="list clr" v-for="(item,index) in quanxiaoData" :key="index" :class="item.paiming ? 'on':''" >
							<template v-if="item.paiming">
								<div class="listcon">
									<div class="titmy">我的排名</div>
									<div class="end clr">
										<div class="num fl"></div>
										<div class="namecon fl clr">
											<img class="fl img" :src="$url+item.avatar" />
											<div class="tit">{{item.username}}</div>
										</div>
										<div class="number fr">{{item.jifen}}</div>
									</div>
								</div>
							</template>
							<template v-else>
								<div class="num fl">{{index+1}}</div>
								<div class="namecon fl clr">
									<img class="fl img" :src="$url+item.avatar" />
									<div class="tit">{{item.username}}</div>
								</div>
								<div class="number fr">{{item.jifen}}</div>
							</template>
						</div>
						
						<div class="list on clr" v-if="Object.keys(quanxiaoMyself).length > 0">
							<div class="listcon">
								<div class="titmy">我的排名</div>
								<div class="end clr">
									<div class="num fl">{{quanxiaoMyself.paiming}}</div>
									<div class="namecon fl clr">
										<img class="fl img" :src="$url+quanxiaoMyself.avatar" />
										<div class="tit">{{quanxiaoMyself.username}}</div>
									</div>
									<div class="number fr">{{quanxiaoMyself.jifen}}</div>
								</div>
							</div>
						</div>
						
					</div>					
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
import {jfpm} from '@/api/control2'
export default {
  data(){
    return {
			height: null,
			quanguoData: [],
			quanshenData: [],
			quanxiaoData: [],
			quanguoMyself: {},
			quanshenMyself: {},
			quanxiaoMyself: {},
		};
	},
	created(){
		this.jfpm();
	},
	methods:{
		jfpm(){
			var that = this;

      let paimingdata = that.utils.storageGet("paimingdata");

			 if(paimingdata.quanguo.myself.paiming <= 10){
					paimingdata.quanguo.data[paimingdata.quanguo.myself.paiming - 1] = paimingdata.quanguo.myself;
				}else{
					that.quanguoMyself = paimingdata.quanguo.myself;
				};
				if(paimingdata.quanshen.myself.paiming <= 10){
					paimingdata.quanshen.data[paimingdata.quanshen.myself.paiming - 1] = paimingdata.quanshen.myself;
				}else{
					that.quanshenMyself = paimingdata.quanshen.myself;
				};
				if(paimingdata.quanxiao.myself.paiming <= 10){
					paimingdata.quanxiao.data[paimingdata.quanxiao.myself.paiming - 1] = paimingdata.quanxiao.myself;
				}else{
					that.quanxiaoMyself = paimingdata.quanxiao.myself;
				};
				that.quanguoData = paimingdata.quanguo.data;
				that.quanshenData = paimingdata.quanshen.data;
				that.quanxiaoData = paimingdata.quanxiao.data;
		}
	},
	mounted(){
		var that = this;
		
	},
	components: {
		
	},
}
</script>
<style scoped>
	
</style>